<gridster [options]="gridsterOptions">
    @for (item of cards(); track item.gridsterItem) {
        <gridster-item [item]="item.gridsterItem">
            @if (isDashboardEditable() && allowedWidgetsToAddAndRemove.includes(item.type)) {
                <button (click)="removeWidget(item)" class="btn-hover-widget-delete">
                    <i class="material-icons text_align-center">close</i>
                </button>
            }
            <ng-container slDashboardItem [card]="item" />
        </gridster-item>
    }
</gridster>

@if (!isNetvote() || !!fixedConfig()) {
    <span
        #newWidgetDdCtxTrigger="matMenuTrigger"
        [matMenuTriggerFor]="newWidgetDdCtx"
        [style.top]="ctxMenuTopPosition"
        [style.left]="ctxMenuLeftPosition"
        [style.position]="'fixed'"></span>
    <mat-menu #newWidgetDdCtx="matMenu">
        @for (item of allowedWidgetsToAddAndRemove; track item) {
            <button mat-menu-item (click)="addWidget(item)">
                {{ 'Dashboard.' + item | translate }}
            </button>
        }

        @if (editLayoutDefaultSettingsRoleId() === undefined || editLayoutDefaultSettingsRoleId() === null) {
            <button mat-menu-item (click)="onReset()">
                {{ 'General.Reset' | translate }}
            </button>
        }
    </mat-menu>
}
